import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

const initialState = {
  allProperties: [],
};

export const allPropertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    setAllProperties: (state, action) => {
      // Ensure only serializable data is stored
      const { data, headers } = action.payload;

      state.allProperties = {
        data, // Store the response data
        headers: {
          contentType: headers["content-type"], // Serialize only required header fields
          contentLength: headers["content-length"],
        },
      };
    },
  },
});

export const { setAllProperties } = allPropertiesSlice.actions;
export const allPropertiesSelector = (state) =>
  state.allProperties.allProperties;

export default allPropertiesSlice.reducer;
